var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is === 'k-circle')?_c('k-circle',{attrs:{"config":_vm.config},on:{"dragend":_vm.handleDragend,"dragmove":_vm.handleDragmove}}):_c(_vm.is,{tag:"component",attrs:{"config":_vm.config},on:{"dragend":_vm.handleDragend,"dragmove":_vm.handleDragmove}})
}
var staticRenderFns = []

export { render, staticRenderFns }